// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1KiGl","title":"Info_title__1nVT2","selects":"Info_selects__1_WCk","requiredAsterisk":"Info_requiredAsterisk__3Zs4H"};